//
// Copyright 2023 DXOS.org
//

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=js"
// @generated from file dxos/echo/indexing.proto (package dxos.echo.indexing, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file dxos/echo/indexing.proto.
 */
export const file_dxos_echo_indexing: GenFile = /*@__PURE__*/
  fileDesc("ChhkeG9zL2VjaG8vaW5kZXhpbmcucHJvdG8SEmR4b3MuZWNoby5pbmRleGluZyKsAQoJSW5kZXhLaW5kEjAKBGtpbmQYASABKA4yIi5keG9zLmVjaG8uaW5kZXhpbmcuSW5kZXhLaW5kLktpbmQSEgoFZmllbGQYAiABKAlIAIgBASJPCgRLaW5kEhAKDFNDSEVNQV9NQVRDSBAAEg8KC0ZJRUxEX01BVENIEAESDQoJRlVMTF9URVhUEAISCgoGVkVDVE9SEAMSCQoFR1JBUEgQBEIICgZfZmllbGQiXwoLSW5kZXhDb25maWcSLgoHaW5kZXhlcxgBIAMoCzIdLmR4b3MuZWNoby5pbmRleGluZy5JbmRleEtpbmQSFAoHZW5hYmxlZBgCIAEoCEgAiAEBQgoKCF9lbmFibGVkYgZwcm90bzM");

/**
 * @generated from message dxos.echo.indexing.IndexKind
 */
export type IndexKind = Message<"dxos.echo.indexing.IndexKind"> & {
  /**
   * @generated from field: dxos.echo.indexing.IndexKind.Kind kind = 1;
   */
  kind: IndexKind_Kind;

  /**
   * @generated from field: optional string field = 2;
   */
  field?: string;
};

/**
 * Describes the message dxos.echo.indexing.IndexKind.
 * Use `create(IndexKindSchema)` to create a new message.
 */
export const IndexKindSchema: GenMessage<IndexKind> = /*@__PURE__*/
  messageDesc(file_dxos_echo_indexing, 0);

/**
 * @generated from enum dxos.echo.indexing.IndexKind.Kind
 */
export enum IndexKind_Kind {
  /**
   * / Match by typename.
   *
   * @generated from enum value: SCHEMA_MATCH = 0;
   */
  SCHEMA_MATCH = 0,

  /**
   * / Match by field value.
   *
   * @generated from enum value: FIELD_MATCH = 1;
   */
  FIELD_MATCH = 1,

  /**
   * / Match by full text.
   *
   * @generated from enum value: FULL_TEXT = 2;
   */
  FULL_TEXT = 2,

  /**
   * / Match by vector.
   *
   * @generated from enum value: VECTOR = 3;
   */
  VECTOR = 3,

  /**
   * / Match by graph relationships.
   *
   * @generated from enum value: GRAPH = 4;
   */
  GRAPH = 4,
}

/**
 * Describes the enum dxos.echo.indexing.IndexKind.Kind.
 */
export const IndexKind_KindSchema: GenEnum<IndexKind_Kind> = /*@__PURE__*/
  enumDesc(file_dxos_echo_indexing, 0, 0);

/**
 * @generated from message dxos.echo.indexing.IndexConfig
 */
export type IndexConfig = Message<"dxos.echo.indexing.IndexConfig"> & {
  /**
   * @generated from field: repeated dxos.echo.indexing.IndexKind indexes = 1;
   */
  indexes: IndexKind[];

  /**
   * *
   * Is indexing enabled (FEATURE FLAG).
   * If not set, the default is false.
   * TODO(mykola): Delete once we promote it as a production feature.
   *
   * @generated from field: optional bool enabled = 2;
   */
  enabled?: boolean;
};

/**
 * Describes the message dxos.echo.indexing.IndexConfig.
 * Use `create(IndexConfigSchema)` to create a new message.
 */
export const IndexConfigSchema: GenMessage<IndexConfig> = /*@__PURE__*/
  messageDesc(file_dxos_echo_indexing, 1);

